import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import './i18n';

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { createAppStore } from "./state/store/AppStore";

// Through 
import { ThroughProvider } from 'react-through'

// Theme
import PACEThemeProvider from "./theme/theme";

export const redux = createAppStore();

ReactDOM.render(
  <Suspense fallback="loading...">
    <Provider store={redux.store}>
      <PersistGate loading={null} persistor={redux.persistor}>
        <PACEThemeProvider>
          <ThroughProvider>
            <App />
          </ThroughProvider>
        </PACEThemeProvider>
      </PersistGate>
    </Provider>
  </Suspense>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
